import { useState } from "react"

import { Camera, Film, Paintbrush, Sparkles, Trees, Wand2 } from "@/components/icons"
import { cn } from "@/lib/utils"

const PRESETS = [
  { icon: Sparkles, label: "No style", id: "none" },
  { icon: Film, label: "Cinematic", id: "cinematic" },
  { icon: Camera, label: "Realistic", id: "realistic" },
  { icon: Paintbrush, label: "Abstract", id: "abstract" },
  { icon: Trees, label: "Natural", id: "natural" },
  { icon: Wand2, label: "Animated", id: "animated" },
]

export function DemoStyleTemplatePicker() {
  const [selected, setSelected] = useState("none")

  return (
    <div className="bg-card w-full rounded-xl border p-4">
      <p className="mb-3 text-sm font-semibold">Style Presets</p>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-6">
        {PRESETS.map(({ icon: Icon, label, id }) => (
          <button
            key={id}
            type="button"
            className={cn(
              "focus-visible:ring-ring flex flex-col items-center gap-1.5 rounded-lg border p-3 transition-colors focus-visible:ring-2 focus-visible:outline-none",
              selected === id
                ? "border-primary bg-primary/5"
                : "hover:bg-muted/50 border-transparent"
            )}
            onClick={() => setSelected(id)}
          >
            <Icon
              className={cn("h-5 w-5", selected === id ? "text-primary" : "text-muted-foreground")}
            />
            <span className="text-xs">{label}</span>
          </button>
        ))}
      </div>

      {/* Adherence slider mock */}
      <div className="mt-4 border-t pt-3">
        <p className="text-muted-foreground mb-2 text-xs font-medium">Style Strength</p>
        <div className="flex gap-2">
          {["Inspired", "Balanced", "Strict"].map((level) => (
            <div
              key={level}
              className={cn(
                "rounded-full border px-3 py-1 text-xs",
                level === "Balanced"
                  ? "border-primary bg-primary/10 text-primary"
                  : "text-muted-foreground"
              )}
            >
              {level}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
